/**
 * @file routes/_app/settings/route.tsx
 * @description 設定頁面佈局路由（無 UI，僅提供 Outlet）。
 *
 * 所有 settings/* 子頁面均渲染在此 Outlet 中。
 * TanStack Router 慣例：目錄下的 route.tsx 作為目錄的佈局路由。
 */

import { Outlet, createFileRoute } from '@tanstack/react-router';

/** TanStack Router 路由定義 */
export const Route = createFileRoute('/_app/settings')({
  component: () => <Outlet />,
});
